import MTownRes1 from '../MTown Residence/Mtown Residence (1).webp'
import MTownRes2 from '../MTown Residence/Mtown Residence (2).webp'
import MTownRes3 from '../MTown Residence/Mtown Residence (3).webp'
import MTownRes4 from '../MTown Residence/Mtown Residence (4).webp'

const MTownResimages =[
MTownRes1,MTownRes2,MTownRes3,MTownRes4
]

export default MTownResimages;